import { Component } from '@angular/core';

@Component({
  standalone: true,
  selector: 'dcc-spinner',
  template: `<div class="spinner"></div>`,
  styleUrls: ['./spinner.component.scss'],
})
export class SpinnerComponent {}
